export enum ImageSourceTypeEnum {
  WYVERN = 'WYVERN',
  STAFF = 'STAFF',
  OPERATOR = 'OPERATOR',
  GENERIC = 'GENERIC',
}
